import { AfterContentInit, Component, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

import { AppFacadeService } from '@services/app-facade.service';
import { AuthFacadeService } from '@services/auth/auth-facade.service';
import { RouterFacadeService } from '@services/router-facade.service';
import { UserModel } from '@models/index';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.sass']
})
export class ChangePasswordComponent implements AfterContentInit, OnDestroy {
  _subs = new Subscription();
  loggedUser$ = this.appFacadeService.getLoggedUser$();
  loggedUser: UserModel;
  pswChanged$ = this.authFacadeService.getPswChanged$();
  isNewPasswordCorrect: boolean = true;
  error: string;
  changePasswordForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private appFacadeService: AppFacadeService,
    private authFacadeService: AuthFacadeService,
    private routerFacadeService: RouterFacadeService
  ) { }

  ngAfterContentInit() {
    this.changePasswordForm = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
    this._subs.add(
      this.authFacadeService.getError$().subscribe(error => {
        this.error = error.includes('Incorrect username or password.')
          ? 'Incorrect password'
          : error
      })
    );

    this._subs.add(
      this.loggedUser$.subscribe(loggedUser => {
        this.loggedUser = loggedUser
      })
    );

    this._subs.add(
      this.pswChanged$.subscribe(pswChanged => {
        if (pswChanged) {
          Swal.fire({
            title: 'Password changed successfully.',
            text: ``,
            icon: 'success',
            confirmButtonText: 'Return to Dashboard'
          }).then(result => {
            if (result.value) {
              this.authFacadeService.setPswChanged(false);
              this.onBackToDashboard();
            }
          })
        }
      })
    );

    this.appFacadeService.clearError()
  }

  onChangePassword(form: FormGroup) {
    this.isNewPasswordCorrect = form.get('newPassword').value == form.get('confirmPassword').value;

    if (this.isNewPasswordCorrect) {
      this.authFacadeService.changePassword({
        psw: form.get('currentPassword').value,
        newPsw: form.get('newPassword').value
      })
    }
  }

  onBackToDashboard() {
    // let AuthGuard handle redirect
    this.routerFacadeService.navigateTo$("/");
  }

  onFocus() {
    this.isNewPasswordCorrect = true;
    this.appFacadeService.clearError()
  }

  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }
}
